import React, { useEffect, useState } from 'react';

import './status-indicator.scss';

export type StatusType = 'editing' | 'saving' | 'updated' | 'download';

interface StatusIndicatorProps {
	status: StatusType;
	className?: string;
}

const StatusIndicator: React.FC<StatusIndicatorProps> = ({ status, className = '' }) => {
	const [dots, setDots] = useState<string>('.');

	useEffect(() => {
		let interval: NodeJS.Timeout;

		if (status === 'saving') {
			interval = setInterval(() => {
				setDots(prev => {
					if (prev === '.') return '..';
					if (prev === '..') return '...';
					return '.';
				});
			}, 500);
		} else {
			setDots('.');
		}

		return () => {
			if (interval) clearInterval(interval);
		};
	}, [status]);

	const getStatusText = () => {
		switch (status) {
			case 'editing':
				return 'Не сохранено';
			case 'saving':
				return `Сохранение${dots}`;
			case 'updated':
				return 'Сохранено';
			case 'download':
				return 'Загрузка';
			default:
				return '';
		}
	};

	const getStatusIcon = () => {
		switch (status) {
			case 'editing':
				return <div className="status-icon editing">✎</div>;
			case 'saving':
			case 'download':
				return <div className="status-icon saving">⏳</div>;
			case 'updated':
				return <div className="status-icon updated">✓</div>;
			default:
				return null;
		}
	};

	return (
		<div className={`status-indicator ${status} ${className}`}>
			{getStatusIcon()}
			<span className="status-text">{getStatusText()}</span>
		</div>
	);
};

export default StatusIndicator;
